export default "__VITE_ASSET__BrZx5HkY__"